import React from 'react';

const LogoMark = ({ size = 44, title = 'Coil Dock logo' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    role="img"
    aria-label={title}
    className="shrink-0"
  >
    <defs>
      <linearGradient id="steel" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F1F5F9" />
        <stop offset="28%" stopColor="#C8D1DB" />
        <stop offset="54%" stopColor="#9CA8B5" />
        <stop offset="80%" stopColor="#D8E0E8" />
        <stop offset="100%" stopColor="#8693A0" />
      </linearGradient>
      <radialGradient id="core" cx="50%" cy="50%" r="60%">
        <stop offset="0%" stopColor="#0C1015" />
        <stop offset="100%" stopColor="#000000" />
      </radialGradient>
    </defs>
    <rect x="2" y="2" width="60" height="60" rx="14" fill="#11151A" stroke="#2A323A" strokeWidth="2" />

    <circle cx="19" cy="39" r="11.2" fill="url(#steel)" stroke="#7F8C99" strokeWidth="0.9" />
    <circle cx="19" cy="39" r="4.8" fill="url(#core)" />

    <circle cx="32" cy="32" r="16.8" fill="url(#steel)" stroke="#7F8C99" strokeWidth="1" />
    <circle cx="32" cy="32" r="7.1" fill="url(#core)" />
    <path d="M16.6 31.5a15.4 15.4 0 0 1 30.8 0" fill="none" stroke="#EEF2F6" strokeOpacity="0.55" strokeWidth="1.2" />
    <path d="M16.2 35.7a15.8 15.8 0 0 0 31.6 0" fill="none" stroke="#5E6B78" strokeOpacity="0.6" strokeWidth="1.1" />

    <circle cx="47" cy="36.5" r="10.3" fill="url(#steel)" stroke="#7F8C99" strokeWidth="0.85" />
    <circle cx="47" cy="36.5" r="4.2" fill="url(#core)" />

    <path d="M30 24.7h4M29.7 39.2h4.6" stroke="#4D5966" strokeWidth="0.75" strokeLinecap="round" />
  </svg>
);

const BrandLogo = ({ size = 44, showWordmark = true, className = '' }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`.trim()}>
      <LogoMark size={size} />
      {showWordmark ? (
        <div className="leading-tight">
          <p className="font-mono text-sm font-bold uppercase tracking-[0.18em] text-white">Coil Dock</p>
          <p className="font-mono text-[10px] text-accent uppercase tracking-[0.16em]">Coil Cutting Job Work Module</p>
        </div>
      ) : null}
    </div>
  );
};

export default BrandLogo;
